import { useTranslation } from 'react-i18next';
import { Button, Icon } from '@innovationnorway/cl-react';
import React from 'react';

function ResetFilterButtonOld({ onClick, className }: { onClick: () => void; className?: string }) {
  const { t } = useTranslation('buttons');
  return (
    <Button type="button" variant="tertiary" className={className} onClick={onClick}>
      <Icon prefix="fasr" iconName="redo" />
      {t('clearFilter')}
    </Button>
  );
}

export default ResetFilterButtonOld;
